import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSubscriptionConfig,
  saveSubscriptionConfig,
  patchSubscriptionBilling,
  patchSubscriptionApproval,
} from "./thunks";
import { toast } from "react-toastify";

interface SubscriptionConfigState {
  data: any;
  loading: boolean;
  error: string | null;
}

const initialState: SubscriptionConfigState = {
  data: null,
  loading: false,
  error: null,
};

const subscriptionConfigSlice = createSlice({
  name: "subscriptionConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSubscriptionConfig.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as { error: string })?.error ||
          action.error?.message ||
          "Erro ao buscar configuração de assinatura";
      })
      .addCase(saveSubscriptionConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveSubscriptionConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        toast.success("Configuração de assinatura salva com sucesso!");
      })
      .addCase(saveSubscriptionConfig.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as { error: string })?.error ||
          action.error?.message ||
          "Erro ao salvar configuração de assinatura";
      })
      .addCase(patchSubscriptionBilling.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(patchSubscriptionBilling.fulfilled, (state, action) => {
        state.loading = false;
        // Mescla billing retornado com dados existentes se houver
        state.data = action.payload ?? state.data;
        toast.success("Configuração de cobrança atualizada com sucesso!");
      })
      .addCase(patchSubscriptionBilling.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as { error: string })?.error ||
          action.error?.message ||
          "Erro ao atualizar configuração de cobrança";
      })
      .addCase(patchSubscriptionApproval.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(patchSubscriptionApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload ?? state.data;
        const { action: intent } = action.meta.arg;
        toast.success(
          intent === "approve"
            ? "Chave PIX aprovada com sucesso!"
            : "Chave PIX rejeitada com sucesso!",
        );
      })
      .addCase(patchSubscriptionApproval.rejected, (state, action) => {
        state.loading = false;
        const payload = action.payload as { error?: string } | string | null;
        const message =
          typeof payload === "string"
            ? payload
            : payload?.error ||
              action.error?.message ||
              "Erro ao atualizar status da chave PIX";
        state.error = message || null;
        toast.error(message || "Erro ao atualizar status da chave PIX");
      });
  },
});

export default subscriptionConfigSlice.reducer;
